module.exports = __webpack_public_path__ + "img/Palau.c93217ff.png";